/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const FeatureSet = ({ featureSet, featureIndex, item }) => {
    const [listOpen, setListOpen] = useState(false);

    return (
        <div className="feature-set-wrapper">
            <button type="button" className="feature-set-button" onClick={ () => setListOpen(!listOpen) } disabled={ !item }>
                <div className="feature-set-button-text">
                    <span dangerouslySetInnerHTML={ { __html: featureSet } }/>
                    <span className="feature-set-button-subtext">features</span>
                </div>
                <div className={ cx('feature-set-button-arrow', { 'dropdown-open': listOpen }) }/>
            </button>
            <div className={ cx('features-dropdown', { 'dropdown-open': listOpen }) }>
                <ul className={ cx({ 'dropdown-hidden': !listOpen }) }>
                    {item ? item.features.map((feature) => (
                        feature.translations.tooltip ?

                            <li key={ `feature-${ featureIndex }-${ feature.translations.name }` } className="dropdown-item">
                                <span className="with-tooltip">{feature.translations.name}
                                    <span className="dropdown-item-tooltip">
                                        {feature.translations.tooltip}
                                        <svg x="0px" y="0px" viewBox="0 0 255 255"><polygon points="0,0 127.5,127.5 255,0"/></svg>
                                    </span>
                                </span>
                            </li>

                    : <li key={ `feature-${ featureIndex }-${ feature.translations.name }` } className="dropdown-item">{feature.translations.name}</li>
              )) : null}
                </ul>
            </div>
        </div>
    );
};

FeatureSet.propTypes = {
    featureSet: PropTypes.string.isRequired,
    featureIndex: PropTypes.number.isRequired,
    item: PropTypes.shape()
};

FeatureSet.defaultProps = {
    item: null
};

export default FeatureSet;



// WEBPACK FOOTER //
// ./src/components/content/estimation/pricing/FeatureSet.jsx